<div class="settings-view">
    <div class="view__title">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 54 54">
            <defs />
            <path
                d="M51.22 21h-5.052c-.812 0-1.481-.447-1.792-1.197s-.153-1.54.42-2.114l3.572-3.571a2.763 2.763 0 00.814-1.966c0-.743-.289-1.441-.814-1.967l-4.553-4.553c-1.05-1.05-2.881-1.052-3.933 0l-3.571 3.571c-.574.573-1.366.733-2.114.421A1.885 1.885 0 0133 7.832V2.78A2.783 2.783 0 0030.22 0h-6.44A2.783 2.783 0 0021 2.78v5.052c0 .812-.447 1.481-1.197 1.792-.748.313-1.54.152-2.114-.421l-3.571-3.571c-1.052-1.052-2.883-1.05-3.933 0l-4.553 4.553a2.764 2.764 0 00-.814 1.967c0 .742.289 1.44.814 1.966l3.572 3.571c.573.574.73 1.364.42 2.114S8.644 21 7.832 21H2.78A2.783 2.783 0 000 23.78v6.439A2.783 2.783 0 002.78 33h5.052c.812 0 1.481.447 1.792 1.197s.153 1.54-.42 2.114l-3.572 3.571a2.763 2.763 0 00-.814 1.966c0 .743.289 1.441.814 1.967l4.553 4.553c1.051 1.051 2.881 1.053 3.933 0l3.571-3.572a1.887 1.887 0 012.114-.42c.75.311 1.197.98 1.197 1.792v5.052A2.783 2.783 0 0023.78 54h6.439a2.783 2.783 0 002.78-2.78v-5.052c0-.812.447-1.481 1.197-1.792a1.885 1.885 0 012.114.42l3.571 3.572c1.052 1.052 2.883 1.05 3.933 0l4.553-4.553a2.764 2.764 0 00.814-1.967c0-.742-.289-1.44-.814-1.966l-3.572-3.571c-.573-.574-.73-1.364-.42-2.114S45.356 33 46.168 33h5.052A2.783 2.783 0 0054 30.22v-6.44A2.783 2.783 0 0051.22 21zm.78 9.22c0 .43-.35.78-.78.78h-5.052a3.879 3.879 0 00-3.64 2.432 3.877 3.877 0 00.854 4.294l3.572 3.571a.78.78 0 010 1.104l-4.553 4.553a.78.78 0 01-1.104 0l-3.571-3.572c-1.149-1.149-2.794-1.474-4.294-.854A3.879 3.879 0 0031 46.168v5.052c0 .43-.35.78-.78.78h-6.44c-.43 0-.78-.35-.78-.78v-5.052a3.879 3.879 0 00-2.432-3.64 3.985 3.985 0 00-1.533-.311c-1.014 0-1.997.4-2.761 1.164l-3.571 3.572a.78.78 0 01-1.104 0L7.046 42.4a.78.78 0 010-1.104l3.572-3.571a3.879 3.879 0 00.854-4.294A3.88 3.88 0 007.832 31H2.78c-.43 0-.78-.35-.78-.78v-6.44c0-.43.35-.78.78-.78h5.052a3.879 3.879 0 003.64-2.432 3.877 3.877 0 00-.854-4.294l-3.572-3.571a.78.78 0 010-1.104l4.553-4.553a.78.78 0 011.104 0l3.571 3.571a3.88 3.88 0 004.294.854A3.876 3.876 0 0023 7.832V2.78c0-.43.35-.78.78-.78h6.439c.431 0 .781.35.781.78v5.052c0 1.624.932 3.019 2.432 3.64a3.878 3.878 0 004.294-.854l3.571-3.571a.78.78 0 011.104 0l4.553 4.553a.78.78 0 010 1.104l-3.572 3.571a3.879 3.879 0 00-.854 4.294 3.879 3.879 0 003.64 2.432h5.052a.78.78 0 01.78.779v6.44z" />
            <path
                d="M27 18c-4.963 0-9 4.037-9 9s4.037 9 9 9 9-4.037 9-9-4.037-9-9-9zm0 16c-3.859 0-7-3.141-7-7s3.141-7 7-7 7 3.141 7 7-3.141 7-7 7z" />
        </svg>
        Settings
    </div>


    <div class="settings-view__option">
        <div class="settings-view__option-title">
            Fullscreen
        </div>
        <div class="settings-view__option-desc">
            Toggle fullscreen mode on or off. Your choice will be remembered but because of browser behavior, if turned on, you'll be asked to go to fullscreen every time you start up Ex Astris. 
        </div>
        <div class="settings-view__option-input">
            <label><input type="checkbox" value="mainSequence" /> Fullscreen Enabled</label>
        </div>
    </div>

    <div class="settings-view__option">
        <div class="settings-view__option-title">
            Map Size
        </div>
        <div class="settings-view__option-desc">
            Sets the size of the map including the number of stars, starlanes, and civilizations.
        </div>
        <div class="settings-view__option-input">

            <select id="config-map-size">
                <option value="huge">Huge</option>
                <option value="large">Large</option>
                <option value="medium">Medium</option>
                <option value="small">Small</option>
                <option value="tiny">Tiny</option>
            </select>
        </div>


    </div>

      <div class="settings-view__option">
        <div class="settings-view__option-title">
            Stars
        </div>
        <div class="settings-view__option-desc">
            Enable or disable the various star types allowed in the universe.
        </div>
        <div class="settings-view__option-input">
           <label><input type="checkbox" value="mainSequence" /> Main Sequence</label>
           <label><input type="checkbox" value="mainSequence" /> Exotic</label>
           <label><input type="checkbox" value="mainSequence" /> Black Holes</label>
           <label><input type="checkbox" value="mainSequence" /> Nova</label>
        </div>
    </div>

     <div class="settings-view__option">
        <div class="settings-view__option-title">
            Orbital Bodies
        </div>
        <div class="settings-view__option-desc">
            Enable or disable the various objects allowed around a star.
        </div>
        <div class="settings-view__option-input">
           <label><input type="checkbox" value="mainSequence" /> Common</label>
           <label><input type="checkbox" value="mainSequence" /> Non-planet</label>
           <label><input type="checkbox" value="mainSequence" /> Exotic</label>
        </div>
    </div>

     <div class="settings-view__option">
        <div class="settings-view__option-title">
            Planet Formation
        </div>
        <div class="settings-view__option-desc">
            Sets the rules for planet formation. The upper limit sets the hard cap on the number of planets a system can have. Planet formation is still limited by formation likelihood.
        </div>
        <div class="settings-view__option-input">
           <p>
               Planet Limit<br />
               <input type="text" value='20'>
            </p>
            <p>
               Formation Likelihood<br />
               <input type="text" value="0.2">
            </p>
        </div>
    </div>

    <div class="settings-view__option">
        <div class="settings-view__option-title">
            Life
        </div>
        <div class="settings-view__option-desc">
            Sets the rules for life on planets. The minimum and maximum temperature limits set the extreme temperatures limits, in Kelvin, that life can handle. Likelihood sets the chances of a habitable planet actually being inhabited.
        </div>
        <div class="settings-view__option-input">
           <p>
               Likelihood<br />
               <input type="text" value='0.05'>
            </p>
            <p>
               Minimum Temperature (K)<br />
               <input type="text" value="200">
            </p>
            <p>
               Maximum Temperature (K)<br />
               <input type="text" value="400">
            </p>
        </div>
    </div>


</div>